import api from '../../../api';

const path = '/services/all/get';

export const getServicesAllRequest = (id) => api.get(`${path}/${id}`);
export const getServicesAllListRequest = (params) => api.get(path, { params });
